import { useRef, useEffect } from 'react';
import WMTSSource from 'ol/source/WMTS';
import OLTileLayer from 'ol/layer/Tile';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { useOLMap } from '../MapContext';
import { useLayerEffect } from './useLayerEffect';
import { getCrossOriginValue } from './getCrossOriginValue';
export const WMTSLayer = (props) => {
    const map = useOLMap();
    const layerRef = useRef();
    useLayerEffect(layerRef, props.layerOptions);
    useEffect(() => {
        const projection = map.getView().getProjection();
        let tileGrid = undefined;
        if (props.gridParams.resolutions) {
            const matrixIds = props.gridParams.resolutions.map((res, index) => {
                return `${props.matrixIdPrefix || ''}${index}`;
            });
            tileGrid = new WMTSTileGrid({
                origin: props.gridParams.origin,
                resolutions: props.gridParams.resolutions,
                matrixIds,
                tileSize: props.gridParams.tileSize,
            });
        }
        else {
            new Error('The wmts layer needs a resolution definition.');
            return () => null;
        }
        const sourceParams = {
            ...props.sourceOptions,
            crossOrigin: getCrossOriginValue(props.sourceOptions.url),
            projection,
            wrapX: projection.isGlobal(),
            tileGrid,
        };
        const layer = new OLTileLayer({
            source: new WMTSSource(sourceParams),
            visible: props.layerOptions.visible,
            opacity: props.layerOptions.opacity ?? 1,
            minResolution: props.layerOptions.minResolution,
            maxResolution: props.layerOptions.maxResolution,
            zIndex: props.layerOptions.zIndex,
        });
        layerRef.current = layer;
        map.addLayer(layer);
        if (process.env.NODE_ENV === 'development') {
            console.debug('new WMTSLayer', map, layerRef.current);
        }
        return () => {
            // unmount
            const layer = layerRef.current;
            if (layer) {
                map.removeLayer(layer);
                layer.dispose();
                layerRef.current = null;
            }
        };
    }, [map, props.sourceOptions]);
    return null;
};
//# sourceMappingURL=WMTSLayer.js.map